import { useState, useEffect, useMemo } from 'react';

/**
 * Shared hook for credit tab state management.
 * Derives credit categories and auto-selects the first tab.
 * Used by BoldTemplate, CleanTemplate, CreativeTemplate, and PopTemplate.
 */
export default function useCreditsTab(credits) {
  const [activeCreditsTab, setActiveCreditsTab] = useState(null);

  const creditCategories = useMemo(() => (credits ? Object.keys(credits) : []), [credits]);

  useEffect(() => {
    if (creditCategories.length > 0 && !activeCreditsTab) {
      setActiveCreditsTab(creditCategories[0]);
    }
  }, [creditCategories, activeCreditsTab]);

  return { activeCreditsTab, setActiveCreditsTab, creditCategories };
}
